import React, { Component } from 'react'
import { RouterView } from '@merchant-backend/common-components'
import HeaderBlock from '@components/JiaMeng/Common/HeaderBlock'
import { Button } from 'hljd'
import {
  WATER_STORE_PATH,
  WATER_MIRROR_SETTING_PATH,
  MARKETING_CENTER_PATH
} from '@constant'
import style from './style.module.less'
import SideBar from './SideBar'
import { Link } from 'react-router'
import { getJtiPath } from '@util'

export default class extends Component {
  render() {
    return (
      <RouterView
        header={[<Link to={MARKETING_CENTER_PATH}>营销工具</Link>, '水镜']}
        title=""
        contentStyle={{
          backgroundColor: 'transparent'
        }}
        bodyStyle={{
          paddingLeft: 0,
          paddingRight: 0
        }}
        sideBar={<SideBar />}
      >
        <HeaderBlock
          title="水镜"
          extra={
            <Button
              type="primary"
              onClick={() => window.open(getJtiPath(WATER_STORE_PATH))}
            >
              下载客户端
            </Button>
          }
          contentStyle={{ padding: '30px' }}
        >
          <div
            className={style.setting}
            onClick={() => window.open(getJtiPath(WATER_MIRROR_SETTING_PATH))}
          >
            <div className={style.title}>可视化配置</div>
            <div>快速配置水镜案例展示</div>
          </div>
        </HeaderBlock>
      </RouterView>
    )
  }
}
